import { render, staticRenderFns } from "./physicalList.vue?vue&type=template&id=17f8d164&scoped=true"
import script from "./physicalList.vue?vue&type=script&lang=js"
export * from "./physicalList.vue?vue&type=script&lang=js"
import style0 from "./physicalList.vue?vue&type=style&index=0&id=17f8d164&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17f8d164",
  null
  
)

export default component.exports